import { motion } from "framer-motion";
import React from "react";

import "./_animated-background-element.scss";

const transition = {
  duration: 200,
  ease: "linear",
  yoyo: Infinity,
};

interface IAnimatedBackgroundElementProps {
  bgImageSrc: string;
  left?: boolean;
  yPos: number;
}

const AnimatedBackgroundElementComponent: React.FC<IAnimatedBackgroundElementProps> = ({
  left = false,
  bgImageSrc,
  yPos,
}) => {
  const animate = { x: [0, left ? -1200 : 1200] };
  const style: any = left
    ? {
        top: yPos * 420,
        left: 0,
      }
    : {
        top: yPos * 420,
        right: 0,
      };

  return (
    <motion.div className="animated-background__element" animate={animate} transition={transition} style={style}>
      <img src={bgImageSrc} />
    </motion.div>
  );
};

export const AnimatedBackgroundElement = React.memo(AnimatedBackgroundElementComponent);
